import React from "react";
import data from "../../data.json";
import styled from "styled-components";

const ContentComponent = ({ selected }) => {
  const listOfarticles =
    selected === "all"
      ? data
      : data.filter((data) => data.type.includes(selected));

  return listOfarticles.map((data, i) => (
    <table key={`table-${i}`}>
      <tbody>
        <tr>
          <td>
            <a href={data.link}>{data.title}</a>
          </td>
          <td>
            <Favourite>{data.favourite}</Favourite>
          </td>
        </tr>
      </tbody>
    </table>
  ));
};

export default ContentComponent;

const Favourite = styled.span`
  font: 400 18px/1.2 Helvetica, sans-serif;
`;
